import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';

const AdministrationUploadProductIndividualPage = lazy(
	() =>
		import('pages/administration/AdministrationUploadProductIndividualPage')
);

export const getAdministrationRoutes = () => [
	<Route
		key="upload-product-individual"
		path="UploadProductIndividual"
		element={
			<LazyRouteElement
				area={createArea(AreaName.Individual, OperationType.Write)}
				Component={AdministrationUploadProductIndividualPage}
				path={'UploadProductIndividual'}
			/>
		}
	/>,
];
